makeWatchQueryOptions